<mat-chip-listbox class="mat-chip-list" color="primary">
  <mat-chip-option *ngFor="let chipElement of chipsElements; trackBy: trackByIndex" (click)="deleteChip(chipElement)" selected="true" color="primary">
    {{chipElement.name}}
    <mat-icon>clear</mat-icon>
  </mat-chip-option>
</mat-chip-listbox>